'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApiTeam = function ApiTeam(Restangular, ApiBaseResponseService) {
    _classCallCheck(this, ApiTeam);

    return {
        getTeams: function getTeams() {
            return Restangular.one('groups').get().then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        },
        getTeam: function getTeam(teamId) {
            return Restangular.one('team', teamId).get().then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        },
        postTeam: function postTeam(team) {
            return Restangular.all('groups').post(team).then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        },
        putTeam: function putTeam(team) {
            return Restangular.one('groups').customPUT(team).then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        },
        deleteTeam: function deleteTeam(team) {
            return Restangular.one('groups').remove().then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        },
        getTeamMembers: function getTeamMembers(param) {
            return Restangular.one('groups/user').get(param).then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        },
        addTeamMember: function addTeamMember(email) {
            return Restangular.all('groups/user').post(null, { userEmail: email }).then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        },
        removeTeamMember: function removeTeamMember(email) {
            return Restangular.one('groups/user').remove({ userEmail: email }).then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        },
        isGroupAdmin: function isGroupAdmin() {
            return Restangular.one('groups/isGroupAdmin').get().then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        },
        getTeamMember: function getTeamMember(userId) {
            return Restangular.one('groups/user', userId).get().then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        }
    };
};

exports.default = ApiTeam;


ApiTeam.inject = ['Restangular', 'ApiBaseResponseService'];


/** WEBPACK FOOTER **
 ** ./src/app/services/apiTeam.js
 **/